<!-- DEPRECATED -->
<script>
	import {
		weatherStore,
		watchWeather,
		clearUpdate,
	} from "$lib/utilities/weatherStore.js";
	import { onDestroy } from "svelte";

	import Weather from "$lib/components/Weather.svelte";

	export let area;

	$: watchWeather(area);

	$: description = $weatherStore?.[area]?.description;
	$: temp = $weatherStore?.[area]?.temp;
	$: icon = $weatherStore?.[area]?.icon;
	$: locationName = $weatherStore?.[area]?.json?.name || area;
	$: country = $weatherStore?.[area]?.json?.sys?.country || "";
	$: feels_like = $weatherStore?.[area]?.json?.main?.feels_like || "";
	$: temp_min = $weatherStore?.[area]?.json?.main?.temp_min || "";
	$: temp_max = $weatherStore?.[area]?.json?.main?.temp_max || "";
	$: humidity = $weatherStore?.[area]?.json?.main?.humidity || "";
	$: pressure = $weatherStore?.[area]?.json?.main?.pressure || "";
	$: visibility = $weatherStore?.[area]?.json?.visibility || "";
	$: speed = $weatherStore?.[area]?.json?.wind?.speed || "";
	$: deg = $weatherStore?.[area]?.json?.wind?.deg || "";
	$: updatedAt = $weatherStore?.[area]?.updatedAt || "";

	$: details = `
    ${locationName}, ${country}
    ${description}
    Temp: ${temp}°F (feels like ${feels_like}°F)
    Min/Max: ${temp_min}°F / ${temp_max}°F
    Humidity: ${humidity}%
    Pressure: ${pressure} hPa
    Wind: ${((speed * 60 * 60) / 1609.34).toFixed(2)} m/h from ${deg}°
    Visibility: ${(visibility / 1609.34).toFixed(2)} mi
    Updated: ${new Date(updatedAt).toLocaleTimeString()}
  `;

	onDestroy(clearUpdate);

	// let updateTimeout;
	// $: (() => {
	//     if (updateTimeout) {
	//         clearTimeout(updateTimeout);
	//     }

	//     if (area) {
	//         updateTimeout = setTimeout(async () => {
	//             await getWeather(area);
	//         }, 1000);
	//     }
	// })();
</script>

<Weather {icon} {temp} {description} {details} />
